import { defineNuxtRouteMiddleware, navigateTo } from "#app";
import { USER_CENTER_BASE_PATH, stripUserCenterBase } from "~/user-center/routes";
import { getToken } from "~/user-center/src/utils/auth";

export default defineNuxtRouteMiddleware((to) => {
  if (process.server) {
    return;
  }

  if (!to.path.startsWith(USER_CENTER_BASE_PATH)) {
    return;
  }

  const hasToken = Boolean(getToken());
  const requiresAuth = to.meta.requiresUserCenterAuth !== false;

  if (!hasToken && requiresAuth) {
    const redirect = stripUserCenterBase(to.fullPath) || "/mall/home";
    return navigateTo(
      `${USER_CENTER_BASE_PATH}/login?redirect=${encodeURIComponent(redirect)}`,
      { replace: true },
    );
  }

  if (hasToken && to.path === `${USER_CENTER_BASE_PATH}/login`) {
    return navigateTo(`${USER_CENTER_BASE_PATH}/mall/home`, { replace: true });
  }
});
